module.exports = __webpack_public_path__ + "img/ico5.dc0be681.png";